<i18n lang='yml' src='../i18n/ProgramStandardIndex.yml'></i18n>
<template>
  <tabs :locale="locale" :tab_objects="[{name: programStandardName, path: '#', active: true},
                                        {name: trainingStandardName, path: createTrainingStandardPath(), active: false}]">
    <div class="action-bar">
            <a class="btn btn-sm btn-success ml-auto mb-4" :href="createNewPath()">
        <font-awesome-icon :icon="['fas', 'plus']"/>
        <span> {{ $t('new_program_standard') }} </span>
      </a>
      <span class="margin-bottom">
        {{$t('guiding_text') }}
      </span>
    </div>

    <filter-bar v-if="filterParams" :filter_params="filterParams" :filter_path="createIndexPath()"/>

    <div class="alert alert-danger" role="alert" v-if="error">
      {{$t('loading_error') }}
    </div>
    
    <div v-else-if="programStandards.count == 0">
      <div class="alert alert-warning" role="alert">
        {{noDataError}}
      </div>
    </div>

    <div class="media-list has-dropdown" >
      <div class="content-block" v-for="item in programStandards.items" :key="item.id">      
        <div class="post-meta">
          <ul class="list-inline list-annotation">
            <li>
              <h5 class="container-item-name">
                {{ item.trade_code }} {{ item.version }}
              </h5>
            </li>
            <li class="ml-auto">
              <div class="btn-group btn-group-sm ml-auto" role="group">
                <a class="btn btn-outline-primary" :href="createEditPath(item.id)">
                  <font-awesome-icon :icon="['fas', 'edit']"/>
                  <span> {{ $t('edit') }} </span>
                </a>
              </div>
            </li>
          </ul> 
        </div> 
          
          <div class="post-meta">
            <ul class="list-unstyled list-inline list-annotation">
              <li>
                <font-awesome-icon :icon="['far', 'clock']"/>
                <span :title="$t('last_updated')"> {{ formatDate(item.updated_at) }} </span>
              </li>
              <li v-if="item.program_standard_status.active">
                <font-awesome-icon :icon="['fas', 'check']"/>
                {{ $t('active') }}
              </li>
              <li v-else>      
                <font-awesome-icon :icon="['fas', 'times']"/>
                {{ $t('inactive') }}
              </li>
            </ul>
          </div>
      </div>
      <pagination 
        :page_count="programStandardsPageCount"
        :expansion_threshold="expansion_threshold" 
      />
    </div>
  </tabs>
</template>

<script>
  import Main from '../../../../filter_bar/components/Main.vue';
  import Tabs from './TrainingProgramTabs.vue';
  import pagination from '../../../../shared/pagination/Pagination.vue';
  import {formatDate} from '../../../../shared/typescripts/dates.ts'

  export default { 
    props: [
      'locale',
      'program_standards',
      'base_path',
      'filter_params',
      'program_standards_page_count',
      'expansion_threshold'
    ],
    components: {
      'filter-bar': Main,
      'tabs': Tabs,
      pagination,
    },
    data() {
      return {
        loading: false,
        programStandards: [],
        filterParams: null,
        programStandardName: this.$i18n.t('program_standard_label'),
        trainingStandardName: this.$i18n.t('training_standard_label'),
        error: false,
        programStandardsPageCount: Number(this.program_standards_page_count),
      }
    },
    mounted() {
      this.$i18n.locale = this.locale;
      try{
        this.programStandards = JSON.parse(this.program_standards)
      }
      catch(err) {
        this.error = true;  
      }    
      this.filterParams = this.filter_params
    },

    computed: {
      noDataError: function() {
        let params = this.filterParams;
        try {
          if (params){
            return params['search'].value ? this.$t('no_search') : this.$t('no_data') ;
          }
        }
        catch(err) {
          this.error = true;  
        }    
      },
    },

    methods: {
      /// - Formatting - ///
      formatDate(dateString) {
        return formatDate(dateString)
      },

      /// - Paths - ///

      createNewPath(){
        let newPath = `${this.createIndexPath()}/new`;
        return newPath;
      },

      createEditPath(id){
        let editPath = `${this.createIndexPath()}/${id}/edit`;
        return editPath;
      },

      createIndexPath(){
        let path = `${this.base_path}/program_standards`
        return path;
      },

      createTrainingStandardPath(){
        let path = `${this.base_path}/training_standards`
        return path;
      }
    },
  }
  
</script>
